<div class="d-flex header-container" *ngIf="!isMobileView && !isLinkOff">
    <div class="col-flex ml-2">
        <label class="title mt-3">{{data?.business}}, {{data?.outlet}}</label>
        <p *ngIf="data?.phone_number || data?.outlet_address" class="mb-2">
          <span *ngIf="data?.phone_number" class="d-flex align-items-center mb-2">
            <img class="mr-1" src="assets/images/icon-phone.svg" alt="phone" width="21" height="21">
            <img class="mr-1" src="assets/images/whatsapp.png" alt="address" width="21" height="21">
            <span class="consumer-phone-address">
              {{data?.phone_number}}
            </span>
          </span>
          <span *ngIf="data?.outlet_address" class="d-flex align-items-center mb-1">
            <img class="mr-1" src="assets/images/icon-address.svg" alt="address" width="21" height="21">
            <span class="consumer-phone-address">
              {{data?.outlet_address}}
            </span>
          </span>
        </p>
        <label *ngIf="data?.is_welcome_banner_text" class="description">{{data.welcome_banner_text}}</label>
    </div>
    <div class="right-sticky-layout" *ngIf="data?.business_logo">
      <div class="logo-container">
        <img class="logo" [src]="data?.business_logo" alt="logo">
      </div>
    </div>
</div>

<div class="header-container" *ngIf="isMobileView && !isLinkOff">
    <div class="col-flex">
        <div *ngIf="data?.business_logo" class="logo-container row m-0 w-100">
            <img class="logo" [src]="data.business_logo" alt="logo">
        </div>
        <label class="title mt-3"> {{data?.business}}, {{data?.outlet}}</label>
        <p *ngIf="data?.phone_number || data?.outlet_address" class="my-2">
          <span *ngIf="data?.phone_number" class="d-flex align-items-center mb-2">
            <img class="mr-1" src="assets/images/icon-phone.svg" alt="phone" width="21" height="21">
            <img class="mr-1" src="assets/images/whatsapp.png" alt="address" width="21" height="21">
            <span class="consumer-phone-address">
              {{data?.phone_number}}
            </span>
          </span>
          <span *ngIf="data?.outlet_address" class="d-flex align-items-center mb-1">
            <img class="mr-1" src="assets/images/icon-address.svg" alt="address" width="21" height="21">
            <span class="consumer-phone-address">
              {{data?.outlet_address}}
            </span>
          </span>
        </p>
        <label *ngIf="data?.is_welcome_banner_text" class="description">{{data.welcome_banner_text}}</label>
    </div>
</div>

<div class="header-container" *ngIf="isLinkOff">
  <div class="col-flex m-0">
      <div *ngIf="data?.business_logo" class="logo-container row m-0 w-100">
        <img class="logo" [src]="data.business_logo" alt="logo">
      </div>
      <label class="link-off-title mt-3 m-auto">{{data?.business}}, {{data?.outlet}}</label>
  </div>
</div>
